import type { FC } from 'react';
import React from 'react';
import { Body, Flex } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import type { CabinClassProps } from './types';

export const CabinClassComponent: FC<CabinClassProps> = ({
  type,
  color,
  weight,
  fontSize,
}) => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center">
      <Body color={color} type={fontSize} weight={weight}>
        {t(`flightSummary.cabinClass.${type}`)}
      </Body>
    </Flex>
  );
};
